/**
 * PostHog · analytics produit de la platform.
 *
 * Inactif sans VITE_POSTHOG_KEY (aucun appel réseau). Pageviews manuels
 * (SPA, voir AppShell), autocapture des clics, identification user +
 * groupe "tenant" pour les analyses par agence dans l'admin.
 *
 * Session replay actif (demande Kevin 12/06/2026) avec masquage de TOUTES
 * les saisies : les mots de passe et données RH/paie restent illisibles
 * dans les enregistrements.
 */
import posthog from "posthog-js";

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;

export const analyticsEnabled = Boolean(KEY);

export function initAnalytics(): void {
  if (!KEY) return;
  posthog.init(KEY, {
    // Proxy first-party Apache (/ph -> cloud EU) : passe les adblockers.
    api_host: "/ph",
    ui_host: "https://eu.posthog.com",
    defaults: "2025-05-24",
    capture_pageview: false, // SPA : $pageview manuel sur changement de route
    capture_pageleave: true,
    cross_subdomain_cookie: true, // même identité que sur myvictor.fr
    person_profiles: "identified_only",
    session_recording: {
      maskAllInputs: true,
    },
  });
}

export function trackPageview(path: string): void {
  if (!KEY) return;
  posthog.capture("$pageview", { $current_url: window.location.origin + path });
}

export function identifyUser(u: {
  id: string;
  email: string;
  prenom?: string;
  nom?: string;
  tenantId?: string;
}): void {
  if (!KEY) return;
  posthog.identify(u.id, {
    email: u.email,
    name: [u.prenom, u.nom].filter(Boolean).join(" ") || undefined,
  });
  if (u.tenantId) posthog.group("tenant", u.tenantId);
}

/** Complète les propriétés du groupe tenant (nom, plan) quand elles arrivent. */
export function setTenantGroup(
  tenantId: string,
  props: Record<string, string | null | undefined>,
): void {
  if (!KEY) return;
  posthog.group("tenant", tenantId, props);
}

export function resetAnalytics(): void {
  if (!KEY) return;
  posthog.reset();
}

export function track(
  event: string,
  properties?: Record<string, string | number | boolean | null>,
): void {
  if (!KEY) return;
  posthog.capture(event, properties);
}
